<template>
  <section class="share-page ypage-box">
    <AppHeader />

    <div class="share-wrap">
      <div class="hero">
        <div class="hero-text">
          <h3>{{ $t('heroTitle') }}</h3>
          <p>{{ $t('heroSubtitle') }}</p>
        </div>
        <img class="hero-img" src="/recovered-assets/bg_share.png" alt="" />
      </div>

      <!-- 只保留「推荐」一个页签 -->
      <div class="page-tabs">
        <button type="button" class="tab-btn active">{{ $t('referral') }}</button>
      </div>

      <div v-if="message" class="msg">{{ message }}</div>

      <div class="invite-panel">
        <div class="invite-head">
          <h4 class="invite-title">{{ $t('inviteLink') }}</h4>
          <button type="button" class="copy-btn" @click="copyText">{{ $t('copy') }}</button>
        </div>
      </div>

      <!-- 三步说明 -->
      <div class="steps-card">
        <div class="step">
          <svg class="step-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
          </svg>
          <div class="step-body">
            <h5>1. {{ $t('step1Title') }}</h5>
            <p>{{ $t('step1Desc') }}</p>
          </div>
        </div>

        <div class="step">
          <svg class="step-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M15 20v-1.6a3.6 3.6 0 0 0-3.6-3.6H6.6A3.6 3.6 0 0 0 3 18.4V20" />
            <circle cx="9" cy="7.2" r="3.6" />
            <path d="M18.6 7.4v5.2M21.2 10h-5.2" />
          </svg>
          <div class="step-body">
            <h5>2. {{ $t('step2Title') }}</h5>
            <p>{{ $t('step2Desc') }}</p>
          </div>
        </div>

        <div class="step">
          <svg class="step-icon" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="9" />
            <path d="M8.2 8.6h7.6M12 8.6V16" />
          </svg>
          <div class="step-body">
            <h5>3. {{ $t('step3Title') }}</h5>
            <p>{{ step3Desc }}</p>
          </div>
        </div>
      </div>
    </div>

    <MobileTabBar current="invite" />
  </section>
</template>

<script>
import { getConfig } from "../recovered/trade-api";
import { getUserInfo } from "../recovered/sign-api";
import MobileTabBar from "../components/MobileTabBar.vue";
import LangSwitch from "../components/LangSwitch.vue";
import QuoteSelect from "../components/QuoteSelect.vue";
import AppHeader from "../components/AppHeader.vue";
import BrandLogo from "../components/BrandLogo.vue";

function toNum(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

export default {
  name: "ShareView",
  components: {
    MobileTabBar,
    LangSwitch,
    QuoteSelect,
    AppHeader,
    BrandLogo,
  },
  i18n: {
    zh: {
      heroTitle: "推荐好友一起挖矿赚取加密货币",
      heroSubtitle: "每天赚取佣金",
      step1Title: "获取链接",
      step1Desc: "连接钱包加入矿池，启动 DeFi 流动性挖矿",
      step2Title: "邀请好友",
      step2Desc: "推荐好友参与挖矿，赚取 USDT",
      step3Title: "赚取加密货币",
      step3Desc: "每天赚取高达 {rate} 的挖矿收益",
      myLevel: "我的等级",
      level1: "1级",
      level2: "2级",
      level3: "3级",
      team: "团队",
      referral: "推荐",
      records: "记录",
      teamSize: "团队规模",
      directReferrals: "直接发起人",
      totalIncomeEth: "总收入(USDC)",
      todayIncomeEth: "今天的收入(USDC)",
      totalIncomeUsdt: "总收入(USDT)",
      todayIncomeUsdt: "今天的收入(USDT)",
      inviteLink: "我的推荐链接",
      copy: "复制",
      inviteTip: "分享给好友后，你将获得对应层级收益奖励。",
      all: "全部",
      source: "来源",
      amount: "金额",
      note: "描述",
      noRecords: "暂无记录",
      loading: "加载中...",
      loadMore: "加载更多",
      linkCopied: "邀请链接已复制",
      copyFailed: "复制失败",
    },
    en: {
      heroTitle: "Refer friends, mine together and earn crypto",
      heroSubtitle: "Earn commission every day",
      step1Title: "Get your link",
      step1Desc: "Connect your wallet to join the pool and start DeFi liquidity mining",
      step2Title: "Invite friends",
      step2Desc: "Refer friends to join mining and earn USDT",
      step3Title: "Earn crypto",
      step3Desc: "Earn up to {rate} in mining income every day",
      myLevel: "My Level",
      level1: "Level 1",
      level2: "Level 2",
      level3: "Level 3",
      team: "Team",
      referral: "Referral",
      records: "Records",
      teamSize: "Team Size",
      directReferrals: "Direct Referrals",
      totalIncomeEth: "Total Income (USDC)",
      todayIncomeEth: "Today's Income (USDC)",
      totalIncomeUsdt: "Total Income (USDT)",
      todayIncomeUsdt: "Today's Income (USDT)",
      inviteLink: "My referral link",
      copy: "Copy",
      inviteTip: "Share with friends to earn tiered rewards.",
      all: "All",
      source: "Source",
      amount: "Amount",
      note: "Note",
      noRecords: "No records",
      loading: "Loading...",
      loadMore: "Load More",
      linkCopied: "Invite link copied",
      copyFailed: "Copy failed",
    },
  },
  data() {
    return {
      message: "",
      config: {
        isEnableRebate: true,
        isShowRebate: true,
        rebateConfigDtos: [],
      },
      userInfo: {
        inviteCode: 0,
        rebateLevel: 0,
        address: "",
      },
    };
  },
  computed: {
    myLink() {
      const code = this.userInfo.invite || this.userInfo.inviteCode || "";
      return `${window.location.protocol}//${window.location.host}?invite=${code}`;
    },
    // 第三步的收益率跟随后台返佣配置，不写死
    step3Desc() {
      return this.$t("step3Desc").replace("{rate}", this.calcBestRate);
    },
    calcBestRate() {
      const list = Array.isArray(this.config.rebateConfigDtos) ? this.config.rebateConfigDtos : [];
      let best = 5;
      list.forEach((x) => {
        if (toNum(x.oneRate) > best) best = toNum(x.oneRate);
      });
      return `${best}%`;
    },
  },
  mounted() {
    this.bootstrap();
  },
  methods: {
    setMessage(msg) {
      this.message = msg || "";
    },
    async bootstrap() {
      try {
        const cfg = await getConfig(document.domain);
        if (cfg && typeof cfg === "object") {
          this.config = {
            ...this.config,
            ...cfg,
            rebateConfigDtos: Array.isArray(cfg.rebateConfigDtos) ? cfg.rebateConfigDtos : [],
          };
        }
      } catch (err) {
        this.setMessage((err && err.message) || "GetConfig failed");
      }

      try {
        const info = await getUserInfo();
        this.userInfo = { ...this.userInfo, ...(info || {}) };
      } catch (err) {
        this.setMessage((err && err.message) || "GetUserInfo failed");
      }

    },
    async copyText() {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(this.myLink);
          this.setMessage(this.$t('linkCopied'));
          return;
        }
      } catch (err) {
        // fallback below
      }

      try {
        const textarea = document.createElement("textarea");
        textarea.value = this.myLink;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.setMessage(this.$t('linkCopied'));
      } catch (err) {
        this.setMessage(this.$t('copyFailed'));
      }
    },
  },
};
</script>

<style scoped>
.share-page {
  min-height: 100vh;
  padding-bottom: 84px;
  background: transparent;
}

.header {
  background: transparent;
}

.header-row {
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  box-sizing: border-box;
}

.lang-btn {
  border: 0;
  background: transparent;
  color: #9aa3b2;
  font-size: 14px;
  padding: 0;
  display: flex;
  align-items: center;
}

.lang-btn::after {
  content: "▼";
  font-size: 10px;
  margin-left: 6px;
  color: #5b6474;
}

.top-title {
  margin: 0;
  font-size: 30px;
  line-height: 1;
  font-weight: 700;
  color: #eef1f6;
}

.addr-pill {
  width: 150px;
  height: 36px;
  border: 1px solid var(--pool-line);
  border-radius: 2px;
  background: var(--pool-glass-2);
  color: var(--pool-muted);
  font-size: 13px;
  line-height: 36px;
  text-align: left;
  padding: 0 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
}

.share-wrap {
  padding: 14px 14px 0;
}

.hero {
  position: relative;
  min-height: 164px;
}

.hero-text {
  width: 57%;
  text-align: left;
  padding-left: 6px;
}

.hero-text h3 {
  margin: 8px 0 0;
  background: var(--pool-grad);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.28;
}

.hero-text p {
  margin: 14px 0 6px;
  color: var(--pool-muted);
  font-size: 15px;
  line-height: 1.25;
}

.hero-img {
  position: absolute;
  right: 6px;
  top: 20px;
  width: 41%;
  max-width: 180px;
}

.page-tabs {
  margin: 22px 0 4px;
  display: flex;
  border-bottom: 1px solid var(--pool-line);
}

.tab-btn {
  position: relative;
  border: 0;
  background: transparent;
  height: 46px;
  min-width: 92px;
  padding: 0 8px;
  color: var(--pool-text);
  font-size: 17px;
  font-weight: 600;
}

.tab-btn.active::after {
  content: "";
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: -1px;
  height: 3px;
  background: var(--pool-grad);
  border-radius: 3px;
}

.msg {
  margin: 0 4px 8px;
  color: var(--pool-bad);
  text-align: left;
  font-size: 12px;
}

.invite-panel,
.steps-card {
  margin-top: 12px;
  background: var(--pool-glass);
  border: 1px solid var(--pool-line);
  border-radius: var(--pool-r);
  box-shadow: 0 20px 40px -34px rgba(0, 0, 0, 0.9);
  padding: 14px 12px;
  position: relative;
  overflow: hidden;
}

.invite-panel::before,
.steps-card::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 1px;
  background: linear-gradient(160deg, rgba(255, 255, 255, 0.14), transparent 40%);
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

.invite-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  position: relative;
  z-index: 1;
}

.invite-title {
  margin: 0;
  text-align: left;
  font-size: 16px;
  color: var(--pool-text);
}

.copy-btn {
  flex: none;
  height: 34px;
  padding: 0 20px;
  border: 0;
  border-radius: 17px;
  color: #04121a;
  background: var(--pool-grad);
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.copy-btn:active {
  opacity: 0.85;
}

/* 三步说明 */
.step {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 2px;
  border-bottom: 1px solid var(--pool-line);
  position: relative;
  z-index: 1;
}

.step:first-child {
  padding-top: 6px;
}

.step:last-child {
  padding-bottom: 6px;
  border-bottom: 0;
}

.step-icon {
  flex: none;
  width: 34px;
  height: 34px;
  stroke: var(--pool-gold);
  fill: none;
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.step-body {
  flex: 1;
  text-align: left;
  min-width: 0;
}

.step-body h5 {
  margin: 2px 0 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--pool-text);
}

.step-body p {
  margin: 6px 0 0;
  font-size: 13px;
  line-height: 1.55;
  color: var(--pool-muted);
}

@media (max-width: 430px) {
  .hero-text h3 {
    font-size: 19px;
  }

  .hero-text p {
    margin-top: 10px;
    font-size: 13px;
  }

  .tab-btn {
    font-size: 16px;
  }

  .step-body h5 {
    font-size: 15px;
  }

  .step-body p {
    font-size: 12px;
  }
}
</style>
